
import React, { Component,Fragment } from "react";
import CustomizedProgressBars from "./spinner";
import Grid from '@material-ui/core/Grid';
import axios from "axios";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Cancel from "./confirmCancel";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import {
  
  CookieName,
  getCookie,
  
} from "../utils/cookieManager";
class MoreD extends Component {
state = {
isLoading: true,
result: {},
error:"",
loading_text:"Fetching Order Details"

}
componentDidMount() {
  const  uTOKEN=getCookie(CookieName.USERTOKEN)?getCookie(CookieName.USERTOKEN):""; 
axios.get(' https://securedapi.confirmtkt.com/api/platform/foodbooking/trackorder', {
params: {
authToken:uTOKEN,
bookingId: this.props.match.params.id,
provider: "RailRestro"
}
}
)
.then((response) => {
// console.log(response.data.outletmap[0].DaysOfRun)  https://reactstrap.github.io


// console.log(response.data);

this.setState({
result: response.data,
isLoading: false,
loading_text:"Fetching Order Details"

});


})
.catch((error)=>{
 
   this.setState({
       error:"Some thing went wrong ",
       isLoading:false,
       loading_text:"Fetching Order Details"
   })

})
;


}

back = () => {
    this.props.history.goBack();
  };




Cancel = () => {
// console.log("cancel......");
const  uTOKEN=getCookie(CookieName.USERTOKEN)?getCookie(CookieName.USERTOKEN):""; 
console.log(uTOKEN);
this.setState({ isLoading: true,
  loading_text:"Requesting Cancellation"
 });
axios.get('https://securedapi.confirmtkt.com/api/platform/foodbooking/cancelfood', {
params: {
authToken:uTOKEN,
bookingId: this.props.match.params.id,
provider: "RailRestro"
}
}
)
.then((response) => {


console.log(response.data)
if (response.data.Status===true) {

console.log(response.data.Status);
alert("Request  for Cancellation Is Taken");
this.setState({
    isLoading:false,
    loading_text:"Fetching Order Details"

})
}

else{
    alert("Conatct RailRestro");
    this.setState({
        isLoading:false,
        loading_text:"Fetching Order Details"

    })
}
});


}



render() {
let colq = "";
let reason="";
let dis = false;
if (this.state.isLoading === false) {
  // console.log(typeOf(this.state.result.status));
  // console.log(this.state.result.status==="UNDELIVERED");
if (this.state.result.status === "CANCELED" ||  this.state.result.status === "UNDELIVERED " ){
  colq = "#ff0f09";
  //  console.log("jkass");
}

else if(this.props.match.params.Status ==="Cancelled")
colq="#d7da18";
else
colq = "#48e83d";


if (this.state.result.status === "CANCELED" || this.props.match.params.Status==="Cancelled" || this.state.result.status === "UNDELIVERED " )
dis = true;
else
dis = false;

if (this.state.result.status === "CANCELED" || this.state.result.status === "UNDELIVERED "){
   reason=this.state.result.reason
  //  console.log(this.state.result.reason)
  }
else if(this.props.match.params.Status==="Cancelled" )
    reason="May be details are not correct";

}



return (
this.state.isLoading === false ?(
(this.state.error === "") ?
<Fragment>
<Grid
          container
          alignItems="center"
          spacing={1}
          style={{
            backgroundColor: "#45A04A",
            position: "fixed",
            margin:"0px",
            top: 0,
            zIndex: 100
          }}
        >
          <Grid item xs={2} style={{ marginLeft: "10px" }}>
            <IconButton
              edge="start"
              style={{ color: "white" }}
              onClick={this.back}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item xs={8} style={{ fontSize: "18px", color: "white" }}>
            Order Details
          </Grid>
        </Grid>
 

        <Grid
          container
          style={{
            position: "fixed",
            margin:"0px",
            backgroundColor: "white",
            bottom: 0,
            zIndex: 100,
            width: "100%",
            height: "10%",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
          }}
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography align="center">
              
                <Cancel cancel={this.Cancel} dis={dis} />   
               
            
            </Typography>
          </Grid>
        </Grid>





<Container style={{backgroundImage:"linear-gradient(to right,#F1F1F1,white)",marginTop:"70px",marginBottom:"60px"}}>
<Grid container alignItems="center" spacing={2}>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Date
</Grid>
<Grid item xs={6} >
{this.state.result.date}
</Grid>
</Grid>
</Grid>

<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Order ID
</Grid>
<Grid item xs={6}>
{this.state.result.userOrderId}
</Grid>
</Grid>


</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Train No.
</Grid>
<Grid item xs={6}>
{this.state.result.trainNo}
</Grid>
</Grid>



</Grid>
<Grid item xs={12}>

<Grid container >
<Grid item xs={6}>
Train Name
</Grid>
<Grid item xs={6} >
{this.state.result.trainName}
</Grid>
</Grid>


</Grid>

<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Station Name
</Grid>
<Grid item xs={6} style={{ float: "right" }}>
{this.state.result.stationName}
</Grid>
</Grid>
</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
PNR
</Grid>
<Grid item xs={6}>
{this.state.result.pnr}
</Grid>
</Grid>

</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Coach
</Grid>
<Grid item xs={6}>
{this.state.result.coach}
</Grid>
</Grid>

</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Seat
</Grid>
<Grid item xs={6}>
{this.state.result.seat}
</Grid>
</Grid>

</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
STA
</Grid>
<Grid item xs={6}>
{this.state.result.sta}
</Grid>
</Grid>

</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
ETA
</Grid>
<Grid item xs={6}>
{this.state.result.eta}
</Grid>
</Grid>

</Grid>
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>

Status
</Grid>
<Grid item xs={6} >
<Typography style={{ color: colq }}>
{this.state.result.status}
</Typography>
</Grid>
</Grid>

</Grid>
{/* // {this.state.result.status === "CANCELED" || this.props.match.params.Status==="Cancelled"? */}
<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Reason
</Grid>
<Grid item xs={6}>
{reason}
</Grid>
</Grid>


</Grid>


<Grid item xs={12}>
<Grid container>
<Grid item xs={6}>
Amount Payable
</Grid>
<Grid item xs={6}>
₹{this.state.result.payable_amount}
</Grid>
</Grid>

</Grid>
<Grid item xs={12}>
<Grid container>

<Grid item xs={12}>
<Typography align="center" color="textSecondary" style={{ fontWeight: "bold", fontSize: 18, marginTop: "5%" }}>
Menu
</Typography>
<Container style={{backgroundColor: "#eaedf1fa", marginBottom: "2%" }}>

{this.state.result.menu.map((e) => {
return (


<Grid item xs={12}  key={e.itemName}  >
<Grid container>
<Grid item xs={8}>
{e.itemName}
</Grid>

<Grid item xs={4} style={{ float: "right" }}>
{e.quantity}
</Grid>



</Grid>
</Grid>



)
})}

</Container>
</Grid>





</Grid>

</Grid>

{/* <Grid item xs={12}>
<Grid container>
<Grid item md={5} xs={3}>

</Grid>
<Grid item md={7} xs={8} style={{marginTop:5}}>

<Cancel cancel={this.Cancel} dis={dis} />


</Grid>
</Grid>

</Grid> */}

</Grid>
</Container> 
</Fragment>
:
<div style={{marginTop:50}} >
   { alert("Error occured during fetching  the details") }
    <Typography variant="body" align="center" color="textSecondary">
    {this.state.error}
    </Typography>
     {this.props.history.goBack()} 
</div>
)




:
(<Container>
    <Typography variant="h5" color="textSecondary" align="center" style={{marginTop:10,marginBottom:150}}>
      
    </Typography> 
    <div style={{textAlign:"center",marginBottom:5}}> 
    <CustomizedProgressBars />
    </div>
    <Typography variant="h5" color="textSecondary" align="center" >
       {this.state.loading_text}  
    </Typography> 
    </Container>)
    

)

}

};
export default MoreD;